export default __webpack_public_path__ + "static/media/bgValorant.4a3403be.jpg";